import { getLocaleDotRound } from "./getLocaleDotRound";

export function getPrintableAmount(amount, multiplier, decimals) {
	const n = parseFloat(amount / multiplier);
	// formatto la stringa in base al locale attuale
	let ln = n.toLocaleString();
	// acquisisco il carattere della virgola utilizzato per il locale del paese
	const round = getLocaleDotRound().round;

	if (ln.indexOf(round) < 0) {
		// non c'è la virgola, aggiungo virgola + decimals decimali
		if (decimals > 0) {
			ln += round;
			for (let i = 0; i < decimals; i++) {
				ln += '0';				
			}			
		}
	} else {
		// c'è gia la virgola, aggiungo i numeri decimali mancanti
		const zeroMancanti = decimals - ln.split(round)[1].length;
		for (let i = 0; i < zeroMancanti; i++) {
			ln += '0';
		}
	}	
    
    return `${ln}`;
}
